import {
  Box,
  Button,
  Flex,
  Grid,
  Label,
  Text,
  Textarea,
  Spinner
} from 'theme-ui';
import { uploadMedia } from '../../../store/api';
import { FaPaperclip, FaTimes } from 'react-icons/fa';
import deleteIcon from "../../../Components/assets/images/Icon/delete.svg";
import editIcon from "../../../Components/assets/images/edit.svg";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import {
  addCommentActionHighlight,
  deleteCommentActionHighlight,
  editCommentActionHighlight
} from '../../../store/actions/action.Highlighters';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { DeletePopModule } from '../../DeletePopModule/DeletePopModule';
import theme from '../../../theme';
import moment from 'moment';
import { linkifyText } from '../../../utils/textFormat';
import { LuPenLine } from 'react-icons/lu';
import { AddCommentActionProps, CommentItem } from '../../../../@types';

// const linkifyText = (text: string): JSX.Element[] => {
//   const urlRegex = /(https?:\/\/[^\s]+)/g;
//   const emailRegex = /[\w.-]+@[\w.-]+\.\w+/g;
//   const parts = text.split(/(\s+)/); // Preserve whitespace
//   return parts.map((part, index) => {
//     if (urlRegex.test(part)) {
//       return (
//         <a
//           key={index}
//           href={part}
//           target="_blank"
//           rel="noopener noreferrer"
//           style={{ color: '#1976d2', textDecoration: 'underline' }}
//         >
//           {part}
//         </a>
//       );
//     } else if (emailRegex.test(part)) {
//       return (
//         <a
//           key={index}
//           href={`mailto:${part}`}
//           style={{ color: '#1976d2', textDecoration: 'underline' }}
//         >
//           {part}
//         </a>
//       );
//     } else {
//       return <span key={index}>{part}</span>;
//     }
//   });
// };



const AddCommentAction = ({ actionId, nameDec, commnets, actionObject, level, colorMode = 'light' }: AddCommentActionProps) => {
  const [updateComment, setUpdateComment] = useState<string>();
  const [oldComment, setOldComment] = useState<string>();
  const [isEditing, setIsEditing] = useState<number | null>(null);
  const [deleteData, setDeleteData] = useState<string>("");
  const [isDeleteModelOpen, setIsDeleteModelOpen] = useState<boolean>(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const dispatch = useDispatch();

  const [attachments, setAttachments] = useState<string[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string>("");

  const [editCommentAttachments, setEditCommentAttachments] = useState<string[]>([]);
  const [isUploadingComment, setIsUploadingComment] = useState(false);
  const [uploadErrorComment, setUploadErrorComment] = useState<string>("");

  const handleCommentFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    setIsUploadingComment(true);
    setUploadErrorComment("");
    const uploadedPaths = [...editCommentAttachments];

    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'chat');
        formData.append('uploadType', 'File');

        const response = await uploadMedia(formData);
        if (response?.data?.status && response?.data?.data) {
          uploadedPaths.push(response.data.data);
        } else {
          setUploadErrorComment('Failed to upload file');
        }
      }
      setEditCommentAttachments(uploadedPaths);
    } catch (err) {
      console.error('File upload error:', err);
      setUploadErrorComment('An error occurred during file upload');
    } finally {
      setIsUploadingComment(false);
      if (event.target) {
        event.target.value = '';
      }
    }
  };

  const removeCommentAttachment = (indexToRemove: number) => {
    setEditCommentAttachments(prev => prev.filter((_, idx) => idx !== indexToRemove));
  };

  const editCommentContainerRef = useRef<HTMLDivElement>(null);
  const isSelectingCommentFile = useRef(false);

  const handleCommentLabelMouseDown = () => {
    isSelectingCommentFile.current = true;
    const onWindowFocus = () => {
      setTimeout(() => {
        isSelectingCommentFile.current = false;
      }, 300);
      window.removeEventListener('focus', onWindowFocus);
    };
    window.addEventListener('focus', onWindowFocus);
  };

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    setIsUploading(true);
    setUploadError("");
    const uploadedPaths = [...attachments];

    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'chat');
        formData.append('uploadType', 'File');

        const response = await uploadMedia(formData);
        if (response?.data?.status && response?.data?.data) {
          uploadedPaths.push(response.data.data);
        } else {
          setUploadError('Failed to upload file');
        }
      }
      setAttachments(uploadedPaths);
    } catch (err) {
      console.error('File upload error:', err);
      setUploadError('An error occurred during file upload');
    } finally {
      setIsUploading(false);
      if (event.target) {
        event.target.value = '';
      }
    }
  };

  const removeAttachment = (indexToRemove: number) => {
    setAttachments(prev => prev.filter((_, idx) => idx !== indexToRemove));
  };

  const renderAttachmentLink = (url: string, index: number) => {
    if (!url) return null;
    const parts = url.split('/');
    const filename = parts[parts.length - 1];
    const cdnUrl = process.env.REACT_APP_CDN_URL || '';
    const fullUrl = url.startsWith('http') ? url : `${cdnUrl}${url}`;

    return (
      <div key={index} style={{ fontSize: '13px', color: '#0dcaf0', marginTop: '8px', display: 'inline-flex', alignItems: 'center', background: 'rgba(13, 202, 240, 0.1)', padding: '6px 12px', borderRadius: '4px', marginRight: '8px' }}>
        <a href={fullUrl} target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
          {filename}
        </a>
      </div>
    );
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: ''
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Check list item is required'),
    }),
    onSubmit: (value) => {
      const newObj = {
        name: nameDec,
        data: {
          name: value.name,
          type: level,
          attachment: [],
        },
        ...actionObject
      };
      dispatch(addCommentActionHighlight(newObj, actionId));
      setAttachments([]);
      formik.resetForm();
    }
  });

  const { handleSubmit, setFieldValue, values, handleBlur, touched, errors } = formik;

  const editActionHighlightComment = () => {
    const isNameChanged = updateComment !== oldComment;
    const originalItem = commnets?.find((item: CommentItem) => item.name === oldComment);
    const originalAttachments = originalItem?.attachment || [];
    const isAttachmentsChanged = JSON.stringify(editCommentAttachments) !== JSON.stringify(originalAttachments);

    if (isNameChanged) {
      const namePayload = {
        name: oldComment,
        data: {
          name: updateComment,
        },
        descriptionName: nameDec
      };
      dispatch(editCommentActionHighlight(namePayload, actionId));
    }

    if (isAttachmentsChanged) {
      const attachmentPayload = {
        name: isNameChanged ? updateComment : oldComment,
        data: {
          attachment: editCommentAttachments,
        },
        descriptionName: nameDec
      };
      dispatch(editCommentActionHighlight(attachmentPayload, actionId));
    }
  };

  const handleSaveCommentRef = useRef(editActionHighlightComment);
  useEffect(() => {
    handleSaveCommentRef.current = editActionHighlightComment;
  }, [editActionHighlightComment]);

  useEffect(() => {
    if (isEditing === null || isEditing === undefined) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        editCommentContainerRef.current &&
        !editCommentContainerRef.current.contains(event.target as Node) &&
        !isSelectingCommentFile.current &&
        !isUploadingComment
      ) {
        handleSaveCommentRef.current();
        setIsEditing(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isEditing, isUploadingComment]);

  const deleteCheckAction = () => {
    dispatch(deleteCommentActionHighlight({ name: deleteData, descriptionName: nameDec }, actionId));
  };

  const filteredComments = commnets?.filter((item: CommentItem) =>
    item.type ? item.type === level : 'clientRequirement'
  );

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
      textareaRef.current.style.marginTop = "15px";
    }
  }, [updateComment]);
  const modalHeader = (colorMode || 'light') === 'light' ? "#f6f6f6" : "#282e42";
  const titleHeader = (colorMode || 'light') === 'light' ? "secondary" : "#dadada";

  return (
    <>
      <Grid
        sx={{
          border: `0.5px solid ${theme?.colors?.text}`,
          background: "#C3ACD029",
          borderRadius: "12px",
          padding: "12px",
          gap: "16px",
          marginTop: '15px',
          overflowY: 'auto'
        }}
      >
        {filteredComments?.map((item: CommentItem, index: number) => (
          <Box key={index} id={`comment-${(item?.name || '').toLowerCase().replace(/[^a-z0-9]/g, '').trim()}`} sx={{ marginBottom: "16px", }}>
            <Flex sx={{ marginBottom: "8px", justifyContent: 'space-between' }}>
              <Text variant="activityText" sx={{ fontWeight: 500, border: 'none' }}>
                {item.updatedBy || 'Someone'}
              </Text>
              <Text sx={{ fontSize: '12px', color: '#8F9195' }}>
                {moment(item.createdAt).format('MMM DD, LT')}
              </Text>
            </Flex>

            <Flex
              sx={{
                paddingLeft: "12px",
                paddingRight: "20px",
                background: modalHeader,
                borderRadius: "8px",
                gap: "10px",
                width: "85%",
                marginLeft: "auto",
                alignItems: "center"
              }}
            >
              {index === isEditing ? (
                <Box
                  ref={editCommentContainerRef}
                  sx={{
                    width: '100%',
                    minHeight: '140px',
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                    background: modalHeader,
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    padding: '8px',
                    flex: 1,
                    my: '8px',
                  }}
                >
                  <Textarea
                    ref={textareaRef}
                    sx={{
                      width: '100%',
                      flex: 1,
                      minHeight: '60px',
                      background: 'transparent',
                      border: 'none',
                      outline: 'none',
                      boxShadow: 'none !important',
                      color: titleHeader,
                      fontSize: '16px',
                      resize: 'vertical',
                      padding: '4px',
                      borderColor: 'transparent !important',
                    }}
                    value={updateComment}
                    onChange={(e) => {
                      setOldComment(item?.name);
                      setUpdateComment(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        editActionHighlightComment();
                        setIsEditing(null);
                      }
                    }}
                    autoFocus
                  />

                  {null}
                </Box>
              ) : (
                <Box
                  sx={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    padding: '12px',
                    borderRadius: '12px',
                    background: modalHeader,
                    color: titleHeader,
                    flex: 1
                  }}
                >
                  {linkifyText(item?.name)}
                  {(item?.attachment || []) && (
                    <Box mt={2}>
                      {Array.isArray(item.attachment)
                        ? (item.attachment).map((url: string, attachIndex: number) => renderAttachmentLink(url, attachIndex))
                        : item.attachment ? renderAttachmentLink(item.attachment, 0) : null}
                    </Box>
                  )}
                </Box>
              )}

              <Flex sx={{ marginLeft: "auto", gap: "1rem" }}>
                <Label
                  htmlFor={`commnetList${index}`}
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    setUpdateComment(item?.name);
                    setOldComment(item?.name);
                    setEditCommentAttachments(Array.isArray(item.attachment) ? item.attachment : (item.attachment ? [item.attachment] : []));
                    setIsEditing(index);
                  }}
                >
                  {colorMode === 'light' ? <img src={editIcon} /> : <LuPenLine style={{ cursor: 'pointer', width: '24px', height: '24px', color: 'white' }} />}

                </Label>
                <Text
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    setIsDeleteModelOpen(true);
                    setDeleteData(item?.name);
                  }}
                >
                  <img src={deleteIcon} width={"23px"} />
                </Text>
              </Flex>
            </Flex>
          </Box>
        ))}

        <Box sx={{ position: "relative", background: modalHeader, borderRadius: "12px", padding: "16px" }}>
          <Box as="div">
            {null}
            <Box
              sx={{
                width: '100%',
                minHeight: '140px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                background: 'transparent',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                padding: '8px',
                '&:focus-within': {
                  borderColor: '#6366f1',
                  boxShadow: '0 0 0 3px rgba(99,102,241,0.12)'
                }
              }}
            >
              <Textarea
                ref={textareaRef}
                placeholder={
                  level === 'clientRequirement'
                    ? `Enter Client's requirement`
                    : `Enter Manager's Reply`
                }
                name={"name"}
                style={{
                  width: '100%',
                  flex: 1,
                  minHeight: '80px',
                  background: 'transparent',
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                  color: titleHeader,
                  fontSize: '16px',
                  resize: 'vertical',
                  padding: '4px',
                }}
                value={values.name}
                onBlur={handleBlur}
                onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
                  setFieldValue("name", event.target.value, true);
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: '12px',
                  paddingTop: '8px',
                  mt: 'auto'
                }}
              >
                {null}
                <Button
                  type='button'
                  onClick={() => handleSubmit()}
                  disabled={isUploading}
                  sx={{
                    borderRadius: "8px",
                    padding: "6px 16px",
                    cursor: isUploading ? 'not-allowed' : 'pointer',
                    backgroundColor: '#7743DB',
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: 500,
                  }}
                >
                  Send
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>

      </Grid>

      <DeletePopModule
        setIsDeleteModelOpen={setIsDeleteModelOpen}
        updatedDataFun={deleteCheckAction}
        isDeleteModelOpen={isDeleteModelOpen}
        message={`Are you sure you want to delete this ${deleteData}`}
      />
    </>
  );
};

export default AddCommentAction;
